import { forwardRef } from "react";

import { MarketCard } from "@/components/MarketCard";
import { ASSIGNMENT_VOCABULARY } from "@/constants/ui/assignment";
import { AssignmentWithContext } from "@/pages/Assignments/AssignmentsPage/AssignmentPage.types";

import { StyledAssignmentHeader, StyledTypeContainer } from "./Styled";

interface AssignmentHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
    item: AssignmentWithContext;
}

export const AssignmentHeader = forwardRef<
    HTMLDivElement,
    AssignmentHeaderProps
>(({ item, ...rest }, ref) => {
    const { assignment, market } = item;

    const Icon =
        ASSIGNMENT_VOCABULARY?.[
            assignment.context.additionalData.assignmentType
        ]?.icon;

    return (
        <StyledAssignmentHeader {...rest} ref={ref}>
            <StyledTypeContainer>
                {Icon && <Icon />}
                <p>{assignment.name}</p>
            </StyledTypeContainer>
            <MarketCard
                address={market?.address?.name}
                fop={market?.contragent?.name}
            />
        </StyledAssignmentHeader>
    );
});

AssignmentHeader.displayName = "AssignmentHeader";
